export default {
  LOAD_STUDENT_COMPETENCY_CERTIFICATE_VIEW_START: 'LoadStudentCompetencyCertificateViewStart',
  LOAD_STUDENT_COMPETENCY_CERTIFICATE_VIEW_END: 'LoadStudentCompetencyCertificateViewEnd'
};